// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components';

/*
export enum Colors {
  RED_PINK = '#ff373c',
  RED = '#ec0000',
  ORANGE = '#ff8228',
  LIGHT_ORANGE = '#ffb432',
  LIGHT_BLUE = '#d2f0ff',
  GREY = '#505050',
  LIGHT_GREY = '#535353',
  BLUE = '#3f75c6',
  GREEN = '#008906',
  LIGHT_GREEN = '#a5bb48',
  PURPLE = '#c34789',
  GREY4 = '#f8f8f8',
  GREY8 = '#f1f1f1',
  GREY16 = '#e3e3e3',
  GREY24 = '#d5d5d5',
  GREY48 = '#ababab',
  GREY80 = '#737373',
  GREY56 = '#232323',
  WHITE = 'white',
  TRANSPARENT = 'transparent'
}*/

export const breakpoints = {
  desktop: 991,
  large: 1200,
  mobile: 575,
  tablet: 768,
};

export var CONFIG = {
  desktop: `screen and (min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop}px)`,
  large: `screen and (min-width: ${breakpoints.desktop + 1}px) and (max-width: ${breakpoints.large -
    1}px)`,
  xlarge: `screen and (min-width: ${breakpoints.large}px)`,
  mobile: `screen and (max-width: ${breakpoints.mobile}px)`,
  tablet: `screen and (min-width: ${breakpoints.mobile +
    1}px) and (max-width: ${breakpoints.tablet - 1}px)`,
};
export const media = {
  desktop: (...args) => css`
    @media only screen and (min-width: ${breakpoints.tablet +
        1}px) and (max-width: ${breakpoints.large}px) {
      ${css(...args)};
    }
  `,
  large: (...args) => css`
    @media only screen and (min-width: ${breakpoints.large + 1}px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media only screen and (max-width: ${breakpoints.mobile}px) {
      ${css(...args)};
    }
  `,
  tablet: (...args) => css`
    @media only screen and (min-width: ${breakpoints.mobile +
        1}px) and (max-width: ${breakpoints.tablet}px) {
      ${css(...args)};
    }
  `,
};

export var MOBILE = 'mobile';

export var TABLET = 'tablet';

export var DESKTOP = 'desktop';

export var LARGE_DESKTOP = 'largeDesktop';
